import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ISystemGroup} from '@netx/core-system-groups/schema';

/**
 * `getGroup` request params
 * (what is used to send to server)
 */
export interface GetGroupRequestOptions {
	id: number;
}

/**
 * `getGroup` request
 * (what gets sent to the server)
 */
export type GetGroupRequest = [GetGroupRequestOptions['id']];

/**
 * `getGroup` response
 * (what comes back from the server)
 */
export type GetGroupResponse = SuccessResponse<
	Omit<ISystemGroup, 'id'> & {groupId: number}
>;

/**
 * `getGroup` result
 * (what is utilized from the server response)
 */
export type GetGroupResult = ISystemGroup;

export const getGroupEndpoint = 'getGroup';

/**
 * Get groups by ids
 * @param fetchParams Fetch params
 */
export const getGroup = async (
	{id}: GetGroupRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetGroupRequest = [id];

	return client
		.post<GetGroupResponse>(getGroupEndpoint, requestParams, {
			signal,
		})
		.then((response) => {
			const {groupId, ...rest} = response.data.result;
			return {
				id: groupId,
				...rest,
			};
		});
};

export default getGroup;
